import React, { useEffect, useState } from 'react';
import {
  Autocomplete,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { addOrUpdateBillingInfo } from '../../../../../services/billingInfo';
import { Root, classes } from './utils';
import closeIcon from '../../../../../assets/accountSetting-assets/x-circle.svg';
import { getLoggedInUserDetail } from '../../../../../services/userApi';
import { getLoggedInUser } from '../../../../../store/userSlice';

const EditManager = ({
  setEditDetailOpen,
  selectedManager,
  setSelectedManager,
  userDetail,
  manager,
}) => {
  const [error, setError] = useState('');
  const [selectedBilling, setSelectedBilling] = useState();
  const dispatch = useDispatch();

  const closeKeyNameForm = () => {
    setSelectedManager(null);
    setError('');
    setEditDetailOpen(false);
  };

  const addOrUpdateBillingInfos = async (id) => {
    await addOrUpdateBillingInfo(id);
    const loggedInUser = await getLoggedInUserDetail();
    dispatch(getLoggedInUser(loggedInUser));
  };

  const handleOnChange = (newValue) => {
    if (newValue) {
      setSelectedManager(newValue.id);
      setError('');
    } else {
      setSelectedManager(null);
    }
  };

  const handleSave = async () => {
    if (!selectedManager) {
      setError('Please select a manager');
      return;
    }
    await addOrUpdateBillingInfos(selectedManager);
    setEditDetailOpen(false);
  };

  useEffect(() => {
    if (manager?.length > 0 && userDetail && Object.keys(userDetail).length) {
      setSelectedBilling({
        value: `${userDetail?.first_name} ${userDetail?.last_name}`,
        label: `${userDetail?.first_name} ${userDetail?.last_name}`,
        id: userDetail?.id,
      });
    }
  }, [manager]);

  return (
    <Root className={classes.root}>
      <Card>
        <CardHeader
          className={classes.CardHeader}
          title={
            <Grid container alignItems="center">
              <Grid item xs={10}>
                <Typography variant="h4">Select Manager For Billing</Typography>
              </Grid>
              <Grid item xs={2} align="right">
                <Avatar
                  onClick={closeKeyNameForm}
                  src={closeIcon}
                  className={classes.closeAction}
                />
              </Grid>
            </Grid>
          }
        />

        <CardContent className={classes.CardContent}>
          {manager?.length === 0 && (
            <Typography variant="body2">No managers available.</Typography>
          )}
          {manager?.length > 0 && (
            <Box component="form" noValidate>
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={manager}
                fullWidth
                size="small"
                value={selectedBilling || null}
                onChange={(e, data) => {
                  handleOnChange(data);
                }}
                getOptionLabel={(option) => option.label}
                renderInput={(params) => (
                  <TextField {...params} label="Manager" />
                )}
              />
              {error && (
                <Typography variant="body2" color="error">
                  {error}
                </Typography>
              )}
            </Box>
          )}
          <Box className={classes.Box}>
            <Button className={classes.CancelButton} onClick={closeKeyNameForm}>
              <Typography variant="body1">Cancel</Typography>
            </Button>
            <Button
              variant="contained"
              className={classes.UpdateButton}
              onClick={handleSave}
            >
              Save
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Root>
  );
};

const userDetailPropTypes = PropTypes.shape({
  first_name: PropTypes.string.isRequired,
  last_name: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
});

const managerPropTypes = PropTypes.shape({
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
});

EditManager.propTypes = {
  setEditDetailOpen: PropTypes.func.isRequired,
  selectedManager: PropTypes.shape({}).isRequired,
  setSelectedManager: PropTypes.func.isRequired,
  userDetail: userDetailPropTypes.isRequired,
  manager: PropTypes.arrayOf(managerPropTypes).isRequired,
};

export default EditManager;
